import React from 'react';

import { MtxGrid } from '@meilleurtaux/mtp-uikit-react';
import { useTranslation } from 'react-i18next';

import { PlacementAssuranceVieResponse, useGetApiPlacementDetails } from '@/api';
import CardDistributionSupport from '@/components/CardDistributionSupport/CardDistributionSupport';
import DemoTag from '@/components/DemoTag/DemoTag';
import Donut from '@/components/donut/donut';
import { DEFAULT_CATEGORY_COLOR } from '@/constants/categoryColors';
import { useDemoContext } from '@/hooks/DemoContext';
import { Support } from '@/services/types/commonResponse';

import styles from './styles.module.css';

interface RepartitionProps {
  placementId: string;
  data: PlacementAssuranceVieResponse;
}

// Les catégories arrivent prêtes à l'affichage : l'API renvoie déjà le libellé canonique, le
// pourcentage, le montant et la couleur (cf. SupportCategoryResolver côté back). On les consomme
// dans l'ordre du tableau, sans retraitement.
export const Repartition: React.FC<RepartitionProps> = ({ placementId, data }) => {
  const { t } = useTranslation();
  const { isDemo } = useDemoContext();
  const { data: placementDetails } = useGetApiPlacementDetails(placementId);

  const categories = placementDetails?.categories ?? [];
  const supports = (placementDetails?.supports ?? []) as unknown as Support[];
  // Seul calcul côté front : l'API ne renvoie pas de total, affiché au centre du donut.
  const globalAmount = categories.reduce((total, category) => total + category.montantTotal, 0);

  return (
    <div className={styles.container}>
      <h2>
        {t('common.distribution')}
        {isDemo && <DemoTag />}
      </h2>
      <MtxGrid row>
        <MtxGrid
          col
          colXs={12}
          offsetXs={0}
          colSm={10}
          offsetSm={1}
          colMd={10}
          offsetMd={0}
          colLg={6}
          offsetLg={0}
          colXl={7}
          offsetXl={0}
        >
          <div className={styles.content}>
            <div className={styles.donutContainer}>
              <Donut
                label={categories.map((category) => category.name ?? '')}
                dataData={categories.map((category) => category.pourcentTotal)}
                background={categories.map((category) => category.couleur ?? DEFAULT_CATEGORY_COLOR)}
                amounts={categories.map((category) => category.montantTotal)}
                globalAmount={globalAmount}
              />
            </div>

            <div className={styles.cardContainer}>
              {categories.map((category) => (
                <div key={category.name ?? ''} className={styles.cardListItem}>
                  <CardDistributionSupport
                    supports={supports}
                    produitName={category.name ?? ''}
                    color={category.couleur ?? DEFAULT_CATEGORY_COLOR}
                    montant={category.montantTotal}
                    completed={category.pourcentTotal}
                    data={data}
                  />
                </div>
              ))}
            </div>
          </div>
        </MtxGrid>
      </MtxGrid>
    </div>
  );
};
